import type React from "react";
import { ChevronRight } from "lucide-react";
import { i18n } from "@frontend/i18n";

interface ProfileSubtitleWithLinkProps {
  readonly subtitle: string;
}

export function ProfileSubtitleWithLink({
  subtitle,
}: ProfileSubtitleWithLinkProps): React.JSX.Element {
  return (
    <span className="text-pds-2xs text-muted-foreground leading-tight flex items-center gap-1">
      {subtitle !== "" && (
        <>
          <span className="truncate">{subtitle}</span>
          <span className="shrink-0">•</span>
        </>
      )}
      <span className="shrink-0 flex items-center gap-0.5 underline underline-offset-2">
        {i18n.t("user.directory.requests.fullProfile")}
        <ChevronRight className="h-3.5 w-3.5" />
      </span>
    </span>
  );
}
